
import { deleteCookie, setCookie } from 'cookies-next';
import { authToken } from '../../utils/helper';
import { ablBaseUrl, apiUrl, baseUrl } from '../../utils/sysEnv';
import * as types from '../types'
import axios from "axios";
import { toast } from "react-toastify";


export const login = data => async dispatch => {
  try {
    dispatch({
      type: types.LOG_OUT, 
      payload: {},
    });
    deleteCookie('loggedInUser');
    dispatch({ type: types.SET_LOADING });
    await axios
      .post(`${baseUrl}/auth/login`, data)
      .then(res => {
          let token = res.data.token;
          // if user is {ceo, finance, id, dev}

          // libango login 
        if(res.data.token){
          axios
          .get(`${baseUrl}/auth/me`, authToken(token), data)
          .then(tmpUser => {
            let newUser = tmpUser.data.data;
            toast.success('Login Success');
            newUser.token = token;
            dispatch({
              type: types.LOGIN,
              payload: newUser,
            });
            setCookie('loggedInUser', JSON.stringify(newUser))
            if(newUser){
                window.location = "/dashboard"; 
            }   
          })
          .catch(error => {
            toast.error('error', 'oops there was an error');
            dispatch({ type: types.RESET });
          });
        }else if (res.data.otpRequired) {
          dispatch({
            type: types.SEND_LOGIN_OTP,
            payload: res.data.ablToken,
          });
          setCookie('ablToken', res.data.ablToken)
          // dispatch({ type: types.RESET });
        } else {
          
        }


      })
      .catch(error => {
      toast.error(error?.response?.data?.error)
      dispatch({ type: types.RESET });
      });
  } catch (error) {
    dispatch({ type: types.RESET });
      toast.error(error?.response?.data?.error)
  //   errorFunction(error, dispatch, types.RESET_AUTH);
  //   reset(types.RESET_CREATE);

  }
};


export const verifyLoginOtp = (info) => async (dispatch) => {
  try {
    dispatch({ type: types.SET_LOADING });
    await axios
      .post(`${baseUrl}/auth/verifyloginotp/`, info)
      .then((res) => {

        let token = res.data.token;
  
        // get loggedIn user info
        axios
        .get(`${baseUrl}/auth/me`, authToken(token))
        .then(tmpUser => {
          let newUser = tmpUser.data.data;
          toast.success('Login Success');
          newUser.token = token;
          dispatch({
            type: types.LOGIN,
            payload: newUser,
          });
          setCookie('loggedInUser', JSON.stringify(newUser))
          toast.success('OTP Verified, Login Success');
          if(newUser){
              window.location = "/dashboard"; 
          }   
        })
        .catch(error => {
          toast.error('error', 'oops there was an error');
          dispatch({ type: types.RESET });
        });

      })
      .catch(error => {
      toast.error(error.response.data.error)
      dispatch({ type: types.RESET });


      })
      .catch((error) => {
        if (error.response === undefined) {
            toast.error(error.message.data.error);
            dispatch({ type: types.RESET });
        } else {
          toast.error(error.response.data.error);
          dispatch({ type: types.RESET });
        }
      });
  } catch (err) {
    dispatch({ type: types.RESET });
    //     setError(dispatch, err.message);
  }
};


  // get client info from accessbank api
  export const accessbankLogin = () => async (dispatch) => {
    try {
      dispatch({ type: types.SET_LOADING });
      await axios
        .post(`${baseUrl}/auth/abl`)
        .then((res) => {
          dispatch({
            type: types.LOGIN,
            payload: res.data.data,
          });
          // window.location = '/'
          // toast.success('Login Success')
        })
        .catch((error) => {
             toast.error(error.response.data.error);
            //   setError(dispatch, error.response.data.error)
          
        });
    } catch (err) {
    }
  };


export const createClient = (data) => async (dispatch) => {
    
    try {
      dispatch({ type: types.SET_LOADING });
      await axios
        .post(`${baseUrl}/auth`, data)
        .then((res) => {
          dispatch({
            type: types.CREATE_USER,
            payload: res.data.data,
          });
          window.location = "/clients";
        })
        .catch((error) => {
          if (error.response === undefined) {
            toast.error(error.response.data.error);
            dispatch({ type: types.RESET_LOADING });
            //   setError(dispatch, error.message)
          } else {
             toast.error(error.response.data.error);
             dispatch({ type: types.RESET_LOADING });
            //   setError(dispatch, error.response.data.error)

          }
        });
    } catch (err) {
      dispatch({ type: types.SET_ERROR });
       toast.error(err.message.data.error);
    }
  };

  // get client info from accessbank api
export const verifyClientInfo = info => async (dispatch) => {
    try {
      dispatch({ type: types.SET_LOADING });
      await axios
        .get(`${ablBaseUrl}/Customers/${info.customerId}/ActiveAccounts`, authToken(info.token))
        .then((res) => {

        })
        .catch((error) => {
          if (error.response === undefined) {
            toast.error(error.message.data.error);
            //   setError(dispatch, error.message)
          } else {
             toast.error(error.response.data.error);
            //   setError(dispatch, error.response.data.error)
          }
        });
    } catch (err) {
       toast.error(err.message.data.error);
    }
  };



    // client forget password
export const forgetPassword = info => async (dispatch) => {
  try {
    dispatch({ type: types.SET_LOADING });
    const res = await axios.put(apiUrl('auth', 'requestpasschange'), info);

    dispatch({
      type: types.FORGET_PASSWORD,
      payload: res.data.data,
    });
    toast.success('Password reset sent.');
  } catch (err) {
    const message =
      err?.response?.data?.error ||
      err?.response?.data?.message ||
      (err?.response?.status === 504
        ? 'Password reset service timed out. Please try again shortly.'
        : err?.message) ||
      'Password reset request failed.';

    toast.error(message);
    dispatch({ type: types.RESET });
  }
};



    // client forget password
  export const verifyOtpAndSetNewPassword = info => async (dispatch) => {
      try {
        dispatch({ type: types.SET_LOADING });
        await axios
          .put(apiUrl('auth', 'verifyotp', 'setpassword'), info)
          .then((res) => {
            dispatch({
              type: types.VERIFY_AND_SET_PASSWORD,
              payload: res.data.data,
            });
            toast.success('Password reset successfull.')
            window.location = "/";
            toast.success('Password reset successfull.')
            alert('Password Reset Successful')
          })
          .catch((error) => {
            if (error.response === undefined) {
              toast.error(error.message.data.error);
            } else {
               toast.error( error.response.data.error);
              //   setError(dispatch, error.response.data.error)
            }
          });
      } catch (err) {
         toast.error( err.message.data.error);
      }
    };

  export const logout = () => async dispatch => {
    try {
          //dispatch the log out function to remove the login user from global state and
          dispatch({
            type: types.LOG_OUT,
            payload: {},
          });
          dispatch({
            type: types.CLEAR,
            payload: {},
          });
          deleteCookie('loggedInUser');
          deleteCookie('ablToken');
          window.location = "/"; 
          toast.success('Successfully LoggedOut')
    } catch (error) {
        toast.error(error)
      throw error;
    }
  };


  
